/**
 * The inbox counts shown on the menu badge («Entradas»): entries waiting
 * for a person — unclassified or with an assistant proposal to review.
 * One observable, refreshed when the permissions load and whenever the
 * inbox page changes something.
 */
import Vue from "vue";
import quoteInboxService from "./services/quoteInbox.service";

const state = Vue.observable({
  loaded: false,
  pending: 0,
  unclassified: 0,
  review: 0,
  in_progress: 0,
  done: 0,
  discarded: 0,
});

export function inboxState() {
  return state;
}

export function refreshInboxCount() {
  return quoteInboxService.count().then((counts) => {
    if (!counts) {
      return state;
    }
    ["pending", "unclassified", "review", "in_progress", "done", "discarded"].forEach((key) => {
      state[key] = Number(counts[key]) || 0;
    });
    state.loaded = true;
    return state;
  });
}

export function resetInboxCount() {
  state.loaded = false;
  state.pending = 0;
  state.unclassified = 0;
  state.review = 0;
  state.in_progress = 0;
  state.done = 0;
  state.discarded = 0;
}
